export default __webpack_public_path__ + "static/media/aqua3.6cacb26d.png";